import React, { memo, forwardRef } from "react";
const SvgReplyArrow2 = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M27 12H11a6 6 0 00-6 6v0a6 6 0 006 6h14"
      />
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M22 7l5 5-5 5"
      />
    </svg>
  );
});
SvgReplyArrow2.displayName = "SvgReplyArrow2";
const MemoForwardRef = memo(SvgReplyArrow2);
export default MemoForwardRef;
